import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../library/components/Button";
import InputField from "../../../library/components/InputField";
import { Validators } from "../../../library/utilities/Validator";
import CustomModal from "../../../library/components/Modal/modal";
import '../otp/otp.css';
import backImage from '../../../images/back.png';
import PopUp_Screen from "../popup_screen";

function EmailOtpForm({ otpObject, setOtpObject, data }) {

    let navigate = useNavigate();
    const handleChange = (key, event) => {
        setOtpObject({ ...otpObject, [key]: event });
    }
    const handleClick = (e) => {

        // e.preventDefault();
        // navigate("/home/dashboard");
    }
    const inputfocus = (elmnt) => {
        if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
            const next = elmnt.target.tabIndex - 2;
            if (next > -1) {
                elmnt.target.form.elements[next].focus();
            }
        }
        else {
            const next = elmnt.target.tabIndex;
            if (next < 6) {
                elmnt.target.form.elements[next].focus();
            }
        }
    }
    return (
        <>
            <div className="box">
                <div className="back_to_login">
                    {/* <a  href="/login">Back</a> */}
                    <Link to="/login">
                        <img src={backImage} alt="backImage"/>Back</Link>
                </div>
                <div className="otpHeading">
                    Enter Email OTP
                    <br />
                    {data}
                </div>
                <div className="row otp">
                    <InputField
                        name="otp1"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp1", e)}
                        tabIndex="1"
                        maxLength="1"
                        onKeyPress={() => { }}
                        value={otpObject.otp1}
                        onKeyUp={e => inputfocus(e)}
                    />
                    <InputField
                        name="otp2"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp2", e)}
                        value={otpObject.otp2}
                        tabIndex="2"
                        maxLength="1"
                        onKeyUp={e => inputfocus(e)}
                    />
                    <InputField
                        name="otp3"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp3", e)}
                        value={otpObject.otp3}
                        tabIndex="3"
                        maxLength="1"
                        onKeyUp={e => inputfocus(e)}
                    />
                    <InputField
                        name="otp4"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp4", e)}
                        value={otpObject.otp4}
                        tabIndex="4"
                        maxLength="1"
                        onKeyUp={e => inputfocus(e)}
                    />
                    <InputField
                        name="otp5"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp5", e)}
                        value={otpObject.otp5}
                        tabIndex="5"
                        maxLength="1"
                        onKeyUp={e => inputfocus(e)}
                    />
                    <InputField
                        name="otp6"
                        type="text"
                        inputClass="otpInput"
                        onChange={e => handleChange("otp6", e)}
                        value={otpObject.otp6}
                        tabIndex="6"
                        maxLength="1"
                        onKeyUp={e => inputfocus(e)}
                    />
                </div>
                <div className="seperator">
                    <a href="/otp">Resend OTP in 4:59</a>
                </div>
                <Button btnClass="btn-block submit" value="Verify & Login" onClick={handleClick} type="submit" />
                {/* <button className="btn btn-block submit" onClick={handleClick} type="button">Verify</button> */}
                {/* <hr /> */}
                
                {/* <div className="space"></div> */}
            </div>
        </>
    );
}

export default EmailOtpForm;